import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import type { Vault } from "../contexts/vault-types";

export default function SuggestionsEdit() {
  const { vault } = useParams() as { vault: Vault };
  const navigate = useNavigate();
  const [questions, setQuestions] = useState<string[]>(["", "", ""]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`/api/suggestions?vault=${vault}`)
      .then(r => r.ok ? r.json() : Promise.resolve(["", "", ""]))
      .then((arr: string[]) => setQuestions(arr.slice(0, 3).concat(["", "", ""]).slice(0, 3)));
  }, [vault]);

  const save = async () => {
    setBusy(true);
    await fetch(`/api/suggestions/${vault}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ questions }),
    });
    setBusy(false);
    navigate(-1);
  };

  const update = (i: number, value: string) => {
    setQuestions(prev => prev.map((q, idx) => idx === i ? value : q));
  };

  return (
    <div className="min-h-screen px-4 pt-3 pb-4">
      <button onClick={() => navigate(-1)} className="text-attic-accent text-sm mb-2">‹ Back</button>
      <h2 className="text-lg font-bold mb-3">Edit {vault[0].toUpperCase() + vault.slice(1)} suggestions</h2>
      <p className="text-attic-dim text-xs mb-4">
        Three tap-to-fire questions shown on the Ask page when {vault} is selected.
      </p>
      {[0, 1, 2].map(i => (
        <div key={i} className="mb-3">
          <label className="text-[9px] uppercase font-bold text-attic-dim tracking-wider">Question {i + 1}</label>
          <input
            value={questions[i] ?? ""}
            onChange={e => update(i, e.target.value)}
            placeholder="What did I learn about…?"
            className="w-full border border-attic-border rounded-lg px-3 py-2 text-sm mt-1"
          />
        </div>
      ))}
      <div className="grid grid-cols-2 gap-2 mt-4">
        <button onClick={() => navigate(-1)} className="border border-attic-border rounded-lg py-2 text-xs">Cancel</button>
        <button onClick={save} disabled={busy} className="bg-attic-accent text-white rounded-lg py-2 text-xs disabled:opacity-50">
          {busy ? "Saving…" : "Save"}
        </button>
      </div>
    </div>
  );
}
